module.exports = __webpack_public_path__ + "media/images/lp_team-dcbe293d343e79d6665d286cbeaf6893.webp";